import React from 'react'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { defineMessages } from 'react-intl'
import loadSuggestedPlanAction from 'modules/plan/redux/actions/load-suggested/index.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import TextTitleCondensed from 'components/TextTitleCondensed.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getSuggestedPlanSelect from '@gymaholic/packages/src/modules/plans/selectors/get-suggested/index.js'
import { getIdReduxUtil } from '@gymaholic/packages'
import PlanCircle from 'pages/Creator/Plans/PlanCircle/index.js'
import Flex from 'components/Flex/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

const messages = defineMessages({
  suggestedPlan: {
    id: 'SuggestedPlan.suggestedPlan',
    defaultMessage: 'For You'
  }
})

const ANALYTIC_EVENT = {
  VIEW_SUGGESTED_PLAN: 'VIEW_SUGGESTED_PLAN',
  SHOW_SUGGESTED_PLAN: 'SHOW_SUGGESTED_PLAN'
}

export default function SuggestedPlan () {
  const intl = useIntl()
  const dispatch = useDispatch()
  const suggestedPlan = useSelector(getSuggestedPlanSelect)
  const id = getIdReduxUtil(suggestedPlan)

  React.useEffect(() => {
    if (id) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.SHOW_SUGGESTED_PLAN)
    }
  }, [id])

  React.useEffect(() => {
    dispatch(loadSuggestedPlanAction())
  }, [])

  const handleClick = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.VIEW_SUGGESTED_PLAN)
  }

  if (!id) {
    return
  }

  if (!suggestedPlan) {
    return <></>
  }

  return (
    <Flex
      mt='16px'
      mx='32px'
      py='11px'
      ac
      jc
      bdr
      bd
    >
      <TextTitleCondensed>
        {formatMessageIntlUtil(intl, messages.suggestedPlan)}
      </TextTitleCondensed>

      <PlanCircle
        planId={id}
        onClick={handleClick}
        isSelected
        isRecommended
        showOpenButton
      />
    </Flex>
  )
}
